module.exports = "<div class=\"permission_wrap_box\">\n  <div class=\"show\">\n    <h1>没有权限 !</h1>\n    <p class=\"info\">抱歉，您无权访问。</p>\n    <el-button type=\"danger\" size=\"mini\" round @click=\"backToPrv\">&nbsp;返&nbsp;回&nbsp;</el-button>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/permission/permission.tpl
// module id = zZHM
// module chunks = 1